function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-phone",
  "data-name": "Icon feather-phone",
  d: "M15.576,12.308V14.18a1.248,1.248,0,0,1-1.36,1.248,12.347,12.347,0,0,1-5.384-1.915A12.166,12.166,0,0,1,5.088,9.769,12.347,12.347,0,0,1,3.173,4.36,1.248,1.248,0,0,1,4.414,3H6.286A1.248,1.248,0,0,1,7.534,4.073a8.011,8.011,0,0,0,.437,1.753A1.248,1.248,0,0,1,7.69,7.143L6.9,7.935a9.982,9.982,0,0,0,3.743,3.743l.792-.792a1.248,1.248,0,0,1,1.316-.281,8.011,8.011,0,0,0,1.753.437A1.248,1.248,0,0,1,15.576,12.308Z",
  transform: "translate(-2.667 -2.5)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
});

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.409,
    height: 13.434,
    viewBox: "0 0 13.409 13.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4d0a4cb1064f05f8357d5f96bc785618.svg";
export { ForwardRef as ReactComponent };